<template>
  <div class="gc-page-project-wrap">
    <van-nav-bar class="gc-header-nav" :border="false"
                 title="项目详情"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-project-wrap box">
      <div class="item">
        <span>项目名称：</span>{{ detailInfo.ProName }}
      </div>
      <div class="item">
        <span>项目编号：</span>{{ detailInfo.ProSysno }}
      </div>
      <div class="item">
        <span>项目类型：</span>{{ detailInfo.ProType == 0 ? '月计划' : '临时计划' }}
      </div>
      <div class="item">
        <span>项目金额：</span>¥{{ detailInfo.ProALLMoney }}
      </div>
      <div class="item">
        <span>项目标签：</span>{{ detailInfo.ProSource ? '外部' : '内部' }}
      </div>
      <div class="item">
        <span>项目时间：</span>{{ detailInfo.PlanStartDate.split(' ')[0] }}至{{ detailInfo.PlanOverTime.split(' ')[0] }}
      </div>
      <div class="item" style="display:block">
        <span>项目描述</span>
        <div class="tip">
          {{ detailInfo.ProRemark }}
        </div>
      </div>
    </div>
    <div class="page-dep-wrap box">
      <div class="item">
        <span>验收人员：</span>
        <div class="info">
          <p>{{ detailInfo.AcceptanceName }}</p>
        </div>
      </div>
    </div>
    <div class="page-dep-wrap box">
      <div class="item">
        <span>出资人员：</span>
        <div class="info">
          {{ detailInfo.ProMoneyType == 0 ? '全体人员' : detailInfo.ProMoneyType == 1 ? '部分人员' : '外部' }}
        </div>
      </div>
    </div>
    <div v-if="detailInfo.ProMoneyType==1" class="page-member-wrap box">
      <div class="title">
        <span class="s1">出资人员</span>
        <span class="s2">权重</span>
        <span class="s2">金额</span>
      </div>
      <div class="info-wrap">
        <div class="info-item" v-for="(item,index) in detailInfo.SourceUsersysno" :key="index">
          <span class="s1">{{ item.UserName }}</span>
          <span class="s2">{{ item.PayoutRatio }}</span>
          <span class="s2">{{ item.runratio }}</span>
        </div>
      </div>
    </div>


    <div v-if="detailInfo.PartUsersysno" class="page-member-wrap box">
      <div class="title">
        <span class="s1">收益人员</span>
        <span class="s2">权重</span>
        <span class="s2">进度</span>
      </div>
      <div class="info-wrap">
        <div class="info-item" v-for="(item,index) in detailInfo.PartUsersysno" :key="index">
          <!-- <span class="s1">{{item.UserDepName}}-{{item.Item.Name}}</span> -->
          <span class="s1">{{ item.UserName }}</span>
          <span class="s2">{{ item.PayoutRatio }}</span>
          <span class="s2">{{ item.runratio }}%</span>
        </div>
      </div>
    </div>
    <!-- <template v-if="detailInfo.ProStatus==1">
        <div class="page-jindu-wrap box" >
            <div class="title">个人完成进度</div>
            <van-slider class="jindu-slider" v-model="pValue"  bar-height=".25rem" active-color="#D32F2F" inactive-color="#eee">
                <template #button>
                    <div class="custom-button"><span>{{pValue}}%</span></div>
                </template>
            </van-slider>
        </div>
        <div class="submit-btn" @click="onSubmit">确认修改进度</div>
    </template> -->

    <template v-if="detailInfo.ProStatus==1&&isExecutive">
      <div class="page-jindu2-wrap box" @click="onSubmit">
        <div class="title">个人完成进度
          <div class="jindu">{{ pValue }}%</div>
        </div>
      </div>
    </template>

    <div class="submit-btn" v-if="detailInfo.ProStatus==2&&detailInfo.MasterUserSysno==usersysno" @click="onDeliver(3)">已完成确认交付</div>
    <div class="submit-btn dis" v-if="detailInfo.ProStatus==2&&detailInfo.MasterUserSysno!=usersysno">待交付</div>

    <div class="submit-btn dis" v-if="detailInfo.ProStatus==3&&detailInfo.Acceptance!=usersysno">待验收</div>
    <div class="submit-btn dis" v-if="detailInfo.ProStatus==4">已结束</div>


    <!-- 立项审核 -->
    <div class="review-btn" v-if="detailInfo.ProStatus==0&&detailInfo.Acceptance==usersysno">
      <div class="btn btn1" @click="handleReview(0)">驳 回</div>
      <div class="btn btn2" @click="handleReview(1)">通 过</div>
    </div>
    <div class="submit-btn dis" v-if="detailInfo.ProStatus==0&&detailInfo.Acceptance!=usersysno">待审核</div>
    <!-- 验收审核 -->
    <template v-if="detailInfo.ProStatus==3&&detailInfo.Acceptance==usersysno">
      <div class="project-end-wrap">
        <div class="item">
          <span>实际交付时间：</span>
          <div class="info">{{ detailInfo.OverTime }}</div>
        </div>
        <div class="item">
          <span>实际出资金额：</span>
          ￥
          <!-- {{detailInfo.ProALLMoney}} -->
          <input type="number" v-model="payMoney" class="money">
        </div>
      </div>
      <div class="submit-btn dis" v-if="isEnd">已结束</div>
      <div class="submit-btn" v-else @click="handleDeliver">确 定</div>
    </template>

    <!-- 完成进度 -->
    <van-popup v-model="showWeight" position="bottom">
      <van-picker
        ref="weight"
        show-toolbar
        :columns="columnsWeight"
        @confirm="onConfirmWeight"
        @cancel="showWeight=false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pValue: -1,
      detailInfo: {
        Item: {
          Name: ''
        },
        PlanStartDate: '',
        PlanOverTime: ''
      },
      usersysno: localStorage.getItem('UserSysno'),
      payMoney: '',
      isEnd: false,

      // 进度弹窗
      showWeight: false,
      columnsWeight: [],
      isExecutive: false
    }
  },
  mounted() {
    // 获取项目详情
    this.WebGetDealProjectInfoEx();

    for (let i = 1; i <= 100; i++) {
      this.columnsWeight.push(i)
    }
  },
  methods: {
    WebGetDealProjectInfoEx() {
      let data = {
        DepSysno: this.$route.params.sysno,
        UserId: localStorage.getItem('UserSysno')
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebNewGetDealProjectInfoEx', data, res => {
        console.log(res);
        res = res.WebNewGetDealProjectInfoExResult
        if (res.ResponseCode == 1) {
          this.detailInfo = res.Item;
          res.Item.PartUsersysno.forEach(el => {
            if (el.Usersysno == this.usersysno) {
              this.pValue = Number(el.runratio)
              this.isExecutive = true
            }
          });
        }
      }, err => {
      })
    },
    // 修改项目进度
    WebUpdateProjectStageStatus(pValue) {
      let data = {
        ItemSysNo: this.$route.params.sysno,
        UserSysno: localStorage.getItem('UserSysno'),
        DepSysNo: pValue, //进度
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebNewUpdateProjectStageStatus', data, res => {
        console.log(res);
        res = res.WebNewUpdateProjectStageStatusResult
        if (res.ResponseCode == 1) {
          this.$toast('项目个人进度修改成功')
          this.detailInfo.PartUsersysno.map(el => {
            if (el.Usersysno == this.usersysno) {
              el.runratio = this.pValue
            }
          });
          // this.$router.back()
        }
      }, err => {
      })
    },

    // 立项审核
    WebUpdateSureProInfo(status) {
      let data = {
        Item: {
          ProSysno: this.$route.params.sysno,
          ProStatus: status,//0不通过  1通过
        }
      }
      this.$baseajax.sliceRequest(this.$base.baseProject + '/WebNewUpdateSureProInfo', data, res => {
        console.log(res);
        if (res.ResponseCode == 1) {
          this.$toast('审核完成')
          // this.$router.back()
          this.$router.go(-1);
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },
    // 立项审核通过、不通过
    handleReview(status) {
      this.$dialog.confirm({
        title: '提示',
        message: '确认操作吗？',
        confirmButtonColor: '#D32F2F'
      }).then(() => {
        this.WebUpdateSureProInfo(status)
      }).catch(() => {
      })

    },
    // 验收审核项目
    handleDeliver() {
      if (!this.payMoney || this.payMoney == 0) {
        this.$toast('请输入实际出资金额')
        return
      }
      // if(!this.detailInfo.ProALLMoney||this.detailInfo.ProALLMoney==0){
      //     this.$toast('网络异常请稍后重试')
      //     return
      // }
      let data = {
        Item: {
          ProSysno: this.$route.params.sysno,
          PayMoney: this.payMoney//交付金额
          // PayMoney: this.detailInfo.ProALLMoney//交付金额
        }
      }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebUpdatePayProMsg', data, res => {
        console.log(res);
        res = res.WebUpdatePayProMsgResult;
        if (res.ResponseCode == 1) {
          this.$toast('已验收完成')
          // this.$router.back();
          this.isEnd = true
        } else {
          this.$toast(res.ResponseMessage)
        }

      }, err => {
      })
    },
    // 修改项目进度
    onSubmit() {
      this.showWeight = true
      this.$nextTick(() => {
        this.$refs.weight.setValues([this.pValue]);
      })
      // this.WebUpdateProjectStageStatus(this.pValue);
    },
    onConfirmWeight(v) {
      this.showWeight = false
      this.pValue = v
      this.WebUpdateProjectStageStatus(v);
    },


    // 参与项目
    WebUpdateAddJoinStageItemStatus() {
      let data = {
        Item: {
          UserSysno: localStorage.getItem('UserSysno'),
          ProSysno: this.$route.params.sysno,
          StageStatus: 0//0参与 1审核通过  2驳回
        }
      }
      this.$baseajax.sliceRequest(this.$base.baseProject + '/WebUpdateAddJoinStageItemStatus', data, res => {
        console.log(res);
        if (res.ResponseCode == 1) {
          this.$toast('已提交申请等待审核')
          this.detailInfo.pruStatus = 0
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },
    // 交付项目
    WebDelInfo(status) {
      let data = {
        Status: status,  //3交付项目 4验收项目
        ItemSysNo: this.$route.params.sysno,
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebDelInfo', data, res => {
        console.log(res);
        res = res.WebDelInfoResult
        if (res.ResponseCode == 1) {
          this.$toast('已交付')
          this.$router.back()
        }
      }, err => {
      })
    },
    onJoinSubmit() {
      this.WebUpdateAddJoinStageItemStatus()
    },
    // 完成项目
    onFinish() {
      this.$dialog.confirm({
        title: '提示',
        message: '是否确认完成？',
        confirmButtonColor: '#D32F2F'
      }).then(() => {
        this.WebUpdateProjectStageStatus(100, 2)
      }).catch(() => {
      })

    },
    // 交付项目
    onDeliver(status) {
      this.$dialog.confirm({
        title: '提示',
        message: '确认交付项目吗？',
        confirmButtonColor: '#D32F2F'
      }).then(() => {
        this.WebDelInfo(status)
      }).catch(() => {
      })

    },


  },
}

</script>


<style lang="less" scoped>
.gc-page-project-wrap {
  .jindu-slider {
    margin-top: 0.7rem;
    opacity: 1;

    /deep/ .custom-button {
      position: relative;
      font-size: 0.28rem;
      color: #666666;
      width: 0.39rem;
      height: 0.39rem;
      border-radius: 100%;
      background-color: #D32F2F;
      box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.4);

      span {
        position: absolute;
        bottom: -0.7rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.project-end-wrap {
  margin: .28rem .28rem 0;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  line-height: 2;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .item {
    display: flex;
    align-items: center;
    padding: .4rem 0;
    border-top: 1PX solid #eee;
    font-size: 0.37rem;
    color: #666666;

    &:first-child {
      border-top: none;
    }

    span {
      width: 3rem;
      flex: 0 0 3rem;
      color: #333333;
    }

    .money {
      padding: .15rem .2rem;
      margin-left: 0.1rem;
      line-height: 1;
      width: 2.6rem;
      // min-width: 2rem;
      font-size: 0.37rem;
      color: #666666;
      background-color: #f0f0f0;
      border-radius: 0.13rem;
    }
  }
}

.page-jindu2-wrap {
  padding-top: .2rem;
  padding-bottom: .2rem;

  .title {
    font-size: 0.37rem;
    color: #333333;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .jindu {
      font-size: 0.7rem;
      color: #D32F2F;
    }
  }
}

// .gc-page-project-wrap{
//     .box{
//         margin: .28rem .28rem 0;
//         padding-left: 0.5rem;
//         padding-right: 0.5rem;
//         line-height: 2;
//         background-color: #ffffff;
//         box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
//         border-radius: 0.27rem;
//         .item{
//             display: flex;
//             padding: .4rem 0;
//             border-top: 1PX solid #eee;
//             font-size: 0.37rem;
// 	        color: #666666;
//             &:first-child{
//                 border-top: none;
//             }
//             span{
//                 width: 2rem;
//                 flex: 0 0 2rem;
//                 // font-size: 0.4rem;
// 	            color: #333333;
//             }
//         }
//         .tip{
//             margin-top: 0.3rem;
//             min-height: 3rem;
//             background-color: #f0f0f0;
//             border-radius: 0.13rem;
//             line-height: 1.6;
//             padding: .2rem .3rem;
//             font-size: 0.37rem;
// 	        color: #666666;
//         }
//     }
//     .page-member-wrap{
//         padding-top: .5rem;
//         padding-bottom: .5rem;
//         text-align: center;
//         position: relative;
//         &:after{
//             content: '';
//             position: absolute;
//             left: 46%;
//             top: 0.5rem;
//             bottom: 0.5rem;
//             width: 1PX;
//             background: #eee;
//         }
//         .s1{
//             width: 50%;
//             padding-right: 10%;
//             text-align: left;
//         }
//         .s2{
//             width: 25%;
//             display: flex;
//             justify-content: space-around;
//             .btn{
//                 padding: .1rem .2rem;
//                 font-size: 0.27rem;
//                 border-radius: 0.13rem;
//                 border: solid 1PX #D32F2F;
//                 &.btn1{
//                     color: #D32F2F;
//                 }
//                 &.btn2{
//                     color: #fff;
//                     background-color: #D32F2F;
//                 }
//             }
//         }
//         .title{
//             display: flex;
//             margin-bottom: 0.2rem;
//             font-size: 0.37rem;
//             color: #333333;
//             justify-content: space-between;
//         }
//         .info-wrap{
//             font-size: 0.27rem;
// 	        color: #666666;
//             .info-item{
//                 margin-top: 0.2rem;
//                 display: flex;
//                 justify-content: space-between;
//             }
//         }
//         .input-wrap{
//             width: 1.3rem;
//             margin-left: auto;
//             margin-right: auto;
//             line-height: 0.6rem;
//             background-color: #f0f0f0;
//             // border: 1px solid #eee;
//             border-radius: 0.13rem;
//             font-size: 0.27rem;
// 	        color: #666666;
//             .input{
//                 width: .7rem;
//                 text-align: center;
//             }
//         }
//     }
//     .page-jindu-wrap{
//         padding-top: .5rem;
//         padding-bottom: 1rem;
//         .title{
//             font-size: 0.37rem;
// 	        color: #333333;
//         }
//     }
//     .jindu-slider{
//         margin-top: 0.7rem;
//         opacity: 1;
//         /deep/.custom-button{
//             position: relative;
//             font-size: 0.21rem;
//             color: #666666;
//             width: 0.39rem;
//             height: 0.39rem;
//             border-radius: 100%;
//             background-color: #D32F2F;
//             box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.4);
//             span{
//                 position: absolute;
//                 bottom: -0.7rem;
//                 left: 50%;
//                 transform: translateX(-50%);
//             }
//         }
//     }
//     .submit-btn{
//         width: 8.8rem;
//         margin: 1rem auto .5rem;
//         height: 1.04rem;
//         line-height: 1.04rem;
//         background-color: #D32F2F;
//         box-shadow: 0rem 1PX 0.09rem 0rem rgba(26, 26, 26, 0.29);
//         border-radius: 0.2rem;
//         font-size: 0.47rem;
//         color: #ffffff;
//         text-align: center;
//     }
//     .review-btn{
//         margin-top: 1rem;
//         margin-bottom: 0.5rem;
//         display: flex;
//         justify-content: space-around;
//         .btn{
//             width: 4rem;
//             padding: .16rem 0;
//             border-radius: 0.2rem;
// 	        border: solid 0.03rem #D32F2F;
//             border-radius: 0.2rem;
//             text-align: center;
//             font-size: 0.47rem;
//             &.btn1{
//                 color: #D32F2F;
//             }
//             &.btn2{
//                 box-shadow: 0rem 0.01rem 0.09rem 0rem rgba(26, 26, 26, 0.29);
//                 background-color: #D32F2F;
//                 color: #ffffff;
//             }
//         }
//     }
// }
</style>



// WEBPACK FOOTER //
// src/views/project/ProjectDetail.vue